import { AnalyticsService, TransactionData } from "./analytics-service";
import { readAttributionCookie } from "@common/utils/attributionReader";

export enum SubscriptionEvent {
  Subscribe = "subscribe",
  Unsubscribe = "unsubscribe",
  Upgrade = "upgrade",
  Downgrade = "downgrade",
}

const analyticsService = new AnalyticsService();

export const trackSubscriptionEvent = (event: SubscriptionEvent, properties: Record<string, any> = {}) => {
  analyticsService.event(event, {
    category: "subscription",
    ...properties,
  });
};

export const trackPurchase = (transaction: TransactionData) => {
  // Read attribution data to include in purchase event
  const attribution = readAttributionCookie();

  // Create enhanced purchase event with attribution data
  const purchaseEvent: TransactionData & Record<string, any> = {
    ...transaction,
  };

  // Add click IDs when available (use most recent/last one)
  if (attribution) {
    if (attribution.conversion_ids?.gclids?.length > 0) {
      purchaseEvent.gclid = attribution.conversion_ids.gclids[attribution.conversion_ids.gclids.length - 1];
    }
    if (attribution.conversion_ids?.fbclids?.length > 0) {
      purchaseEvent.fbclid = attribution.conversion_ids.fbclids[attribution.conversion_ids.fbclids.length - 1];
    }
    if (attribution.conversion_ids?.msclkids?.length > 0) {
      purchaseEvent.msclkid = attribution.conversion_ids.msclkids[attribution.conversion_ids.msclkids.length - 1];
    }
    if (attribution.conversion_ids?.ttclids?.length > 0) {
      purchaseEvent.ttclid = attribution.conversion_ids.ttclids[attribution.conversion_ids.ttclids.length - 1];
    }

    // Add UTM params from first-touch attribution
    if (attribution.first_touch?.utm_source) {
      purchaseEvent.utm_source = attribution.first_touch.utm_source;
    }
    if (attribution.first_touch?.utm_medium) {
      purchaseEvent.utm_medium = attribution.first_touch.utm_medium;
    }
    if (attribution.first_touch?.utm_campaign) {
      purchaseEvent.utm_campaign = attribution.first_touch.utm_campaign;
    }
    if (attribution.first_touch?.utm_content) {
      purchaseEvent.utm_content = attribution.first_touch.utm_content;
    }
    if (attribution.first_touch?.utm_term) {
      purchaseEvent.utm_term = attribution.first_touch.utm_term;
    }
  }

  analyticsService.transaction(purchaseEvent);
};

 